import { faCalendar, faUserClock } from "@fortawesome/free-solid-svg-icons";
import { EventClickArg } from "@fullcalendar/react";
import { useState, useCallback } from "react";
import { ListarAgendaTecnicoController } from "../../../../../Controllers/AssistenciaTecnica/Agendamento/AgendamentoControllers";
import { IAgendaTecnicoRequest } from "../../../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import DescricaoEventoAgendamento from "../../../../../Pages/AssistenciaTecnica/AgendaAssistenciaTecnica/DescricaoEventoAgendamento";
import ModalComponent from "../../../../Modais";
import { IComponentModal } from "../../../../Modais/IModalComponent";
import DescricaoEventoDisponivelVistoria from "../../../../../Pages/AssistenciaTecnica/AgendaAssistenciaTecnica/DescricaoEventoCompromissoDisponivelVistoria";
import moment from "moment";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import AgendaComponent from "./AgendaComponent";
import LazySelect from "../../../Forms/LazySelect";
import { ListarUsuariosAtivosComAcessoCasoController } from "../../../../../Controllers/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasController";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IAgendaComponentProps {
    flApenasAgendamentosDoUsuario?: boolean;
    responsivo?: boolean;
}

export default function AgendaModal(props: IAgendaComponentProps) {
    const {
        ListarEventos,
        eventClick,
        modal,
        idUsuario,
        setShow,
        show,
        setIdUsuario,
        setAtualizaAgenda,
    } = useMetadata();

    return (
        <>
            <LazySelect
                label="Técnico"
                controller={ListarUsuariosAtivosComAcessoCasoController}
                getDS={(e) => e.DS_NOME}
                className={`form-control placeholder-dark-50 mb-5`}
                getKeyValue={(e) => e.ID_USUARIO}
                onChange={(e) => setIdUsuario(Number(e.target.value))}
                name="ID_USUARIO"
            >
                <option />
            </LazySelect>
            {idUsuario !== 0 ? (
                <div className={"w-100 h-100 "}>
                    <AgendaComponent
                        events={ListarEventos}
                        eventClick={eventClick}
                        responsivo={props.responsivo}
                        setAtualizaAgenda={setAtualizaAgenda}
                    />
                </div>
            ) : (
                <div className="d-flex flex-column justify-content-center align-items-center pt-5">
                    <FontAwesomeIcon size="5x" icon={faUserClock} />
                    <h2 className="mt-5">
                        Selecione um técnico para visualizar a agenda
                    </h2>
                </div>
            )}
            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </>
    );
}

// hook que concentra lógica
function useMetadata() {
    const [atualizaAgenda, setAtualizaAgenda] = useState(false);

    const [idUsuario, setIdUsuario] = useState(0);
    const lstEtapasTipoCaso = [
        {
            nrEtapa: 1,
            color: "red",
        },
        {
            nrEtapa: 2,
            color: "red",
        },
        {
            nrEtapa: 3,
            color: "red",
        },
        {
            nrEtapa: 4,
            color: "black",
        },
        {
            nrEtapa: 5,
            color: "yellow",
        },
        {
            nrEtapa: 6,
            color: "blue",
        },
        {
            nrEtapa: 7,
            color: "purple",
        },
        {
            nrEtapa: 10,
            color: "green",
        },
    ];

    const { value: lstAgendaTecnica, execute: listarAgendaTecnica } =
        useAsyncCallback(
            async (filtrosDeData: IAgendaTecnicoRequest) => {
                let lstAgendaTecnica: any[] = [];
                await ListarAgendaTecnicoController({
                    ID_USUARIO: idUsuario,
                    DT_INICIO: filtrosDeData.DT_INICIO,
                    DT_FIM: filtrosDeData.DT_FIM,
                }).then((res) => {
                    const concatHorarioAgendado = lstAgendaTecnica.concat(
                        res.HORARIOS_AGENDADOS
                    );
                    lstAgendaTecnica = concatHorarioAgendado.concat(
                        res.HORARIOS_DISPONIVEIS
                    );
                });
                return lstAgendaTecnica;
            },
            [idUsuario, setIdUsuario]
        );

    const ListarEventos = useCallback(
        (eventInfo, successCallback, errorCallback) => {
            listarAgendaTecnica({
                DT_INICIO: eventInfo.start,
                DT_FIM: eventInfo.end,
                ID_USUARIO: idUsuario,
            })
                .then((res: any) => {
                    successCallback(
                        res.map((value: any) =>
                            value.ID_COMPROMISSO_DISPONIVEL_VISTORIA
                                ? {
                                      title: `Horario Disponivel
                                                  ${moment(
                                                      value?.DT_INICIO
                                                  ).format("HH:mm")} -
                                                  ${moment(
                                                      value?.DT_FIM
                                                  ).format("HH:mm")} -
                                                  ${value.DS_PRODUTO} 
                                                  `,
                                      id: value.ID_COMPROMISSO_DISPONIVEL_VISTORIA?.toString(),
                                      start: new Date(value.DT_INICIO),
                                      end: new Date(value.DT_FIM ?? ""),
                                      atualizaAgenda: atualizaAgenda,
                                  }
                                : {
                                      title: `${value.DS_ASSUNTO} - ${value.DS_TIPO_COMPROMISSO}`,
                                      id: value.ID_COMPROMISSO.toString(),
                                      start: new Date(value.DT_INICIO),
                                      end: new Date(value.DT_FIM),
                                      atualizaAgenda: atualizaAgenda,
                                      color:
                                          lstEtapasTipoCaso?.find(
                                              (etapaItem) =>
                                                  etapaItem.nrEtapa ===
                                                  value.NR_ETAPA
                                          )?.color ?? "black",
                                  }
                        )
                    );
                })
                .catch((err: any) => {
                    errorCallback({
                        message: err.message,
                    });
                });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [atualizaAgenda, idUsuario, listarAgendaTecnica]
    );

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    function eventClick(arg: EventClickArg) {
        const agendamento = lstAgendaTecnica?.find(
            (a) => a.ID_COMPROMISSO === Number(arg.event.id)
        );

        if (agendamento) {
            setModal({
                Children: (
                    <DescricaoEventoAgendamento
                        agendamento={agendamento}
                        nome_cliente={agendamento.DS_NOME_CLIENTE}
                    />
                ),
                IconHeader: faCalendar,
                headerComponent: "Evento",
                noHeader: true,
                noFooter: true,
            });
            setShow(true);
        }

        const compromissos = lstAgendaTecnica?.find(
            (c) => c.ID_COMPROMISSO_DISPONIVEL_VISTORIA === Number(arg.event.id)
        );

        if (compromissos) {
            setModal({
                Children: (
                    <DescricaoEventoDisponivelVistoria
                        compromissos={compromissos}
                    />
                ),
                IconHeader: faCalendar,
                noHeader: true,
                noFooter: true,
            });
            setShow(true);
        }
    }

    return {
        setIdUsuario,
        show,
        modal,
        setShow,
        ListarEventos,
        idUsuario,
        eventClick,
        listarAgendaTecnica,
        setAtualizaAgenda,
    };
}
